/**
 * This is a sample widget layout
 */
import Vue from "vue";

Vue.component("announcement-banner-select", () =>
  import("./components/TheBannerSelect.vue")
);
